var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 382,
    viewBox: "0 0 259 382",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_111_5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 132.688,
    cy: 254.901,
    r: 126.218,
    fill: "url(#paint0_linear_111_5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.688,
    cy: 254.901,
    r: 125.718,
    stroke: "url(#paint1_linear_111_5)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_111_5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.5092,
    cy: 55.6375,
    r: 55.0462,
    fill: "url(#paint2_linear_111_5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5092,
    cy: 55.6375,
    r: 54.5462,
    stroke: "url(#paint3_linear_111_5)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_111_5",
    x: -15.3302,
    y: 106.884,
    width: 296.036,
    height: 296.036,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_111_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_111_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_111_5",
    x: -21.337,
    y: -21.2087,
    width: 153.692,
    height: 153.692,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_111_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_111_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_111_5",
    x1: 13.4808,
    y1: 174.375,
    x2: 250.596,
    y2: 334.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AE732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#4AE285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AE64E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_111_5",
    x1: 15.3405,
    y1: 155.777,
    x2: 236.648,
    y2: 326.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.204859,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629663,
    stopColor: "#666666",
    stopOpacity: 0.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_111_5",
    x1: 3.52058,
    y1: 20.5181,
    x2: 106.931,
    y2: 90.2697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AE732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#4AE285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AE64E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_111_5",
    x1: 4.33165,
    y1: 12.4075,
    x2: 100.848,
    y2: 87.0254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.204859,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629663,
    stopColor: "#666666",
    stopOpacity: 0.14
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBubble);
export default __webpack_public_path__ + "static/media/green_bubble.4791379650ca725e24441fd0061bed45.svg";
export { ForwardRef as ReactComponent };